var React = require('react');

function ThunderSliced (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M201.667 -103.052L3.198 153.918C-4.50922 163.897 2.58689 178.398 15.1776 178.398H80.5696C90.5794 178.398 97.8376 187.955 95.1723 197.625L50.7819 358.69C46.2333 375.194 68.1719 385.447 77.8614 371.346L269.908 91.8557C276.83 81.7818 269.635 68.0585 257.431 68.0585H218.674C209.257 68.0585 202.122 59.5388 203.754 50.2431L228.567 -91.1256C231.307 -106.737 211.347 -115.586 201.667 -103.052Z","fill":"#262AC5","fillOpacity":"0.08"}));
}

ThunderSliced.defaultProps = {"width":"273","height":"378","viewBox":"0 0 273 378","fill":"none"};

module.exports = ThunderSliced;

ThunderSliced.default = ThunderSliced;
